import { MessagesSquare } from 'lucide-react';
import type { ModuleMeta } from '../types';

export const meta: ModuleMeta = {
  id: 'chat',
  label: 'Chat',
  route: '/chat',
  icon: MessagesSquare,
};
